import * as React from 'react'

import { PublicUserInfo } from '../../sdk/model';
import { Card, Typography, Box, Avatar, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import SearchUser from './SearchUser';

const getOwnerDisplayName = (owner: PublicUserInfo): string => {
  if (!owner) return 'Owner';
  // Use type assertion to access potential properties
  const ownerAny = owner as any;
  return ownerAny.displayName || ownerAny.username || ownerAny.email || 'Owner';
};

const getOwnerPicture = (owner: PublicUserInfo): string | undefined => {
  if (!owner) return undefined;
  // Use type assertion to access potential picture property
  return (owner as any).picture || undefined;
};

interface manageUserGroupProps {
  title: string,
  initialUsers: PublicUserInfo[],
  omittedUsers: PublicUserInfo[],
  submitChanges: Function
}

function ManageUserGroup(props: manageUserGroupProps) {
  const [forRemoval, setForRemoval] = React.useState(props.initialUsers.map(() => false));
  const [newUsers, setNewUsers] = React.useState<PublicUserInfo[]>([]);
  
  function toggleRemoval(userIndex) {
    const newForRemoval = [...forRemoval];
    newForRemoval[userIndex] = !newForRemoval[userIndex];
    setForRemoval(newForRemoval);
  }
  
  function selectNewUser(newUser: PublicUserInfo) {
    const newUsersCopy = [...newUsers];
    newUsersCopy.push(newUser);
    setNewUsers(newUsersCopy);
  }
  
  function removeNewUser(userIndex) {
    const newUsersCopy = [...newUsers];
    newUsersCopy.splice(userIndex, 1)
    setNewUsers(newUsersCopy);
  }
  
  function submitChanges() {
      let updatedUsers = [...props.initialUsers];
      forRemoval.map((remove, removalIndex) => remove ? removalIndex : null)
          .filter(value => value !== null)
          .reverse()
          .forEach(removalIndex => {
             updatedUsers.splice(removalIndex, 1);
          });
      updatedUsers = updatedUsers.concat(newUsers);
      props.submitChanges(updatedUsers);
    }
  
  const omittedUsers = props.omittedUsers.concat(props.initialUsers).concat(newUsers).map(user => user.id!);
  
  return <Card style={{maxHeight: 800, overflow: 'auto'}}>
    <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
      {props.title}:
    </Typography>
    {props.initialUsers.map((user, userIndex) => {
      const removing = forRemoval[userIndex];
      return <Box key={userIndex}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end', 
            textDecoration: removing ? "line-through" : "", textDecorationColor: removing ? 'red' : '' }}>
          <Typography variant="body2">
            {getOwnerDisplayName(user)}
          </Typography>
          {getOwnerPicture(user) && (
            <Avatar 
              src={getOwnerPicture(user)} 
              sx={{ width: 24, height: 24 }}
            />
          )}
          <Button onClick={() => toggleRemoval(userIndex)}>
            {removing ? <AddIcon /> : <CloseIcon />}
          </Button>
        </Box>
      </Box>
    })}
    {newUsers.map((user, userIndex) => 
      <Box key={userIndex}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end', color: 'green'}}>
          <Typography variant="body2">
            {getOwnerDisplayName(user)}
          </Typography>
          {getOwnerPicture(user) && (
            <Avatar 
              src={getOwnerPicture(user)} 
              sx={{ width: 24, height: 24 }}
            />
          )}
          <Button onClick={() => removeNewUser(userIndex)}>
            <CloseIcon />
          </Button>
        </Box>
      </Box>
    )}
    <Box>
      <SearchUser omittedUsers={omittedUsers} selectUser={selectNewUser} />
    </Box>
    <Button className="capsized-button" onClick={submitChanges}>Submit</Button>
  </Card>
}

export default ManageUserGroup;
